(() => {
  if (window.zardoCartPageReady) return;
  window.zardoCartPageReady = true;
  let running = false;
  let pending = false;
  let timer;
  const root = () => document.querySelector('[data-zardo-cart-page]');
  const cartUrl = (path) => `${window.Shopify?.routes?.root || '/'}${path}`;
  const isService = (item) => [10268500230456, 10721385939256, 10717269721400].includes(item.product_id)
    || item.vendor?.toLowerCase() === 're:do'
    || (item.final_line_price === 0 && /sticker/i.test(item.product_title || item.title || ''))
    || /free zardo gift|free gift|shipping insurance|delivery guarantee|shipping protection/i.test(item.product_title || item.title || '');
  const readJson = async (response) => {
    if (!response.ok) throw new Error('Cart request failed');
    return response.json();
  };
  async function refresh() {
    if (!root()) return;
    if (running) { pending = true; return; }
    running = true;
    try {
      const cart = await fetch(cartUrl('cart.js'), { cache: 'no-store' }).then(readJson);
      if (cart.items.length && cart.items.every(isService)) {
        const updates = Object.fromEntries(cart.items.map((item) => [item.key, 0]));
        await fetch(cartUrl('cart/update.js'), {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates })
        }).then(readJson);
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { source: 'zardo-v2-cart-page' } }));
      }
      const current = root();
      if (!current) return;
      const url = new URL(window.location.href);
      url.searchParams.set('sections', current.dataset.zardoCartPage);
      const sections = await fetch(url, { cache: 'no-store' }).then(readJson);
      const markup = sections[current.dataset.zardoCartPage];
      if (!markup) throw new Error('Cart section unavailable');
      const fresh = new DOMParser().parseFromString(markup, 'text/html').querySelector('[data-zardo-cart-page]');
      if (!fresh) throw new Error('Cart markup unavailable');
      if (fresh.dataset.cartFingerprint !== current.dataset.cartFingerprint) {
        const focused = document.activeElement;
        // Preserve the live checkout form while gift verification is pending.
        if (current.querySelector('form[data-free-gift-checkout-ready="pending"]') ||
            (current.contains(focused) && focused.matches('input:focus, textarea:focus'))) {
          pending = true;
        } else {
          const giftError = current.querySelector('[data-free-gift-error]:not([hidden])');
          const checkoutForm = fresh.querySelector('form.zardo-cart-page__note');
          if (giftError && checkoutForm) checkoutForm.appendChild(giftError.cloneNode(true));
          current.replaceWith(fresh);
        }
      }
      root()?.querySelector('[data-zardo-cart-error]')?.remove();
    } catch (error) {
      const current = root();
      if (current && !current.querySelector('[data-zardo-cart-error]')) {
        const notice = document.createElement('p');
        notice.dataset.zardoCartError = '';
        notice.setAttribute('role', 'alert');
        notice.textContent = current.dataset.refreshError;
        current.append(notice);
      }
    } finally {
      running = false;
      if (pending) { pending = false; schedule(); }
    }
  }
  function schedule(event) {
    if (event?.detail?.source === 'zardo-v2-cart-page') return;
    clearTimeout(timer);
    timer = setTimeout(refresh, 300);
  }
  ['cart:change', 'cart:updated', 'cart:refresh', 'free-gift:cart-updated', 'zardo:cart:upsell-added'].forEach((name) => document.addEventListener(name, schedule));
  window.addEventListener('pageshow', schedule);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) schedule(); });
  [0, 1000, 2500, 5000].forEach((delay) => setTimeout(schedule, delay));
})();
